module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZD0iTTEgMzhoNDZ2Mkgxem0yNC0yMGg0djE2aC00em02IDBoNHYxNmgtNHptNiAwaDR2MTZoLTR6bS0xOCAwaDR2MTZoLTR6bS02IDBoNHYxNmgtNHptLTYgMGg0djE2SDd6bTM2LTJINXYtM2wxOS05IDE5IDl6TTUgMzRoMzh2Mkg1eiIgZmlsbD0iI0ZGOTgwMCIvPjxnIGZpbGw9IiNFRjZDMDAiPjxwYXRoIGQ9Ik0yNSAxNmg0djJoLTR6bTYgMGg0djJoLTR6bTYgMGg0djJoLTR6bS0xOCAwaDR2MmgtNHptLTYgMGg0djJoLTR6bS02IDBoNHYySDd6TTMgMzZoNDJ2MkgzeiIvPjxjaXJjbGUgY3g9IjI0IiBjeT0iMTEiIHI9IjIiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/library.svg
// module id = 3906
// module chunks = 0